import type from "./action-type";
import * as Api from "api/api";
import NewsMenuType from "enum/NewsMenuType";
import FetchFromArr from "utils/FetchFromArr";

export const init = () => {
    return {
        type: type.INIT
    };
};

export const setCategoryList = payload => {
    return {
        type: type.SET_CATEGORY_LIST,
        payload
    };
};

export const setCurrentCategoryIndex = payload => {
    return {
        type: type.SET_CURRENT_CATEGORY_INDEX,
        payload
    };
};

export const setList = payload => {
    return {
        type: type.SET_LIST,
        payload
    };
};

export const setTotalNum = payload => {
    return {
        type: type.SET_TOTAL_NUM,
        payload
    };
};

export const setPageSize = payload => {
    return {
        type: type.SET_PAGE_SIZE,
        payload
    };
};

export const setPageNum = payload => {
    return {
        type: type.SET_PAGE_NUM,
        payload
    };
};

export const setKeyword = payload => {
    return {
        type: type.SET_KEYWORD,
        payload
    };
};

export const setRecommendList = payload => {
    return {
        type: type.SET_RECOMMEND_LIST,
        payload
    };
};

export const setInfo = payload => {
    return {
        type: type.SET_INFO,
        payload
    };
};

export const setMenuType = payload => {
    return {
        type: type.SET_MENU_TYPE,
        payload
    };
};

export const setCategoryId = payload => {
    return {
        type: type.SET_CATEGORY_ID,
        payload
    };
};

export const setLoadingList = payload => {
    return {
        type: type.SET_LOADING_LIST,
        payload
    }
}

export const setLoadingRecommend = payload => {
    return {
        type: type.SET_LOADING_RECOMMEND,
        payload
    }
}

/**
 * 获取列表
 * @param {*} param0
 * @param {*} callback
 */
export const fetchList = ({
                              pageSize,
                              pageNum,
                              categoryId,
                              title,
                              newsMenuType
                          }) => {
    return async f => {
        try {
            f(setLoadingList(true));

            let res;
            if (newsMenuType === NewsMenuType.NEWS) {
                res = await Api.newsList({
                    pageNum,
                    pageSize,
                    categoryId,
                    title
                });
            } else if (newsMenuType === NewsMenuType.VIDEO) {
                res = await Api.videoList({
                    pageSize,
                    pageNum,
                    title
                });
            }

            let {list, totalNum} = res;

            f(setList(list));
            f(setTotalNum(totalNum));

            f(fetchRecommendList({list}));
        } catch (error) {
        } finally {
            f(setLoadingList(false));
        }
    };
};

/**
 * 获取推荐列表
 * @param {*} param0
 */
export const fetchRecommendList = ({list}) => {
    return async f => {
        const MAX_LENGTH = 18;

        f(setLoadingRecommend(true));
        let arr = FetchFromArr([...list], MAX_LENGTH);

        f(setRecommendList(arr));
        f(setLoadingRecommend(false));
    };
};

/**
 * 获取类别列表
 * @param {*} param0
 */
export const fetchCategoryList = ({name, menuType, categoryId}) => {
    return async f => {
        try {
            let {list, totalNum} = await Api.newsCategoryList({
                name
            });

            list = list.map((item, index) => {
                const {id, name, isUrl} = item;

                return {
                    id,
                    name,
                    type: NewsMenuType.NEWS,
                    isUrl
                };
            });

            list = [
                {
                    //   id: -1,
                    id: undefined,
                    name: "视频中心",
                    type: NewsMenuType.VIDEO,
                    isUrl: false
                },
                {
                    //   id: -2,
                    id: undefined,
                    name: "资讯中心",
                    type: NewsMenuType.NEWS,
                    isUrl: false
                },
                ...list
            ];

            //   如果页面参数有 类别类型 和 类别id

            if (menuType) {
                if (menuType === NewsMenuType.VIDEO) {
                    f(setCurrentCategoryIndex(0));
                } else if (menuType === NewsMenuType.NEWS) {
                    if (categoryId) {
                        for (let i = 0; i < list.length; i++) {
                            if (categoryId === list[i].id) {
                                f(setCurrentCategoryIndex(i));
                            }
                        }
                    } else {
                        f(setCurrentCategoryIndex(1));
                    }
                }
            } else {
                if (list.length >= 2) {
                    f(setCurrentCategoryIndex(1));
                } else if (list.length >= 1) {
                    f(setCurrentCategoryIndex(0));
                }
            }

            f(setCategoryList(list));
        } catch (error) {
        }
    };
};

/**
 * 获取详情
 * @param {*} param0
 */
export const fetchInfo = ({menuType, id}) => {
    return async f => {
        try {
            let res;

            if (menuType === NewsMenuType.NEWS) {
                res = await Api.newsInfo({
                    id
                });
            } else if (menuType === NewsMenuType.VIDEO) {
                res = await Api.videoInfo({
                    id
                });
            }

            const {info} = res;

            f(setInfo(info));
        } catch (error) {
        }
    };
};
